
const DevelopmentStage = {
  SOLIDFOOD: 'solid-food',
  WALKING: 'walking',
  POTTYTRAINED: 'potty-trained',
};

module.exports = {
  DevelopmentStage
};
